module.exports = "<div class=\"product\">\n  <p class=\"product__title\">{{product.name}}</p>\n  <div class=\"product__characters\">\n  </div>\n</div>\n"